export default __webpack_public_path__ + "static/media/steering-wheel 1.5449c3bb.svg";